import { render, staticRenderFns } from "./input.component.vue?vue&type=template&id=1a2cb0e8&scoped=true"
import script from "./input.component.vue?vue&type=script&lang=js"
export * from "./input.component.vue?vue&type=script&lang=js"
import style0 from "./input.component.vue?vue&type=style&index=0&id=1a2cb0e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2cb0e8",
  null
  
)

export default component.exports